import { LocationStrategy } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IBaseModel } from '../models/base.model';
import { ITipoDispensaModel } from '../models/tipo-dispensa.model';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root',
})
export class TipoDispensaService extends BaseService {

  constructor(httpClient: HttpClient, locationStrategy: LocationStrategy) {
    super(httpClient, locationStrategy);
  }

  public obter(pesquisa: string, ativo: boolean, simplificado = false): Promise<IBaseModel<ITipoDispensaModel[]>> {
    let params = new HttpParams();
    params = params.append('pesquisa', pesquisa || '');

    if (ativo !== undefined) {
      params = params.append('ativo', ativo.toString());
    }

    if (simplificado) {
      params = params.append('simplificado', simplificado.toString());
    }

    return this.httpClient
      .get<IBaseModel<ITipoDispensaModel[]>>(`${this.apiBaseUrl}/tipodispensa`, { params })
      .toPromise();
  }

  public async obterPorId(id: number): Promise<IBaseModel<ITipoDispensaModel>> {
    return this.httpClient
      .get<IBaseModel<ITipoDispensaModel>>(`${this.apiBaseUrl}/tipodispensa/${id}`)
      .toPromise();
  }

  public async inserir(data: ITipoDispensaModel): Promise<IBaseModel<void>> {
    return this.httpClient
      .post<IBaseModel<void>>(`${this.apiBaseUrl}/tipodispensa`, data)
      .toPromise();
  }

  public async atualizar(data: ITipoDispensaModel): Promise<IBaseModel<void>> {
    return this.httpClient
      .put<IBaseModel<void>>(`${this.apiBaseUrl}/tipodispensa/${data.id}`, data)
      .toPromise();
  }

  public async reativar(id: number): Promise<IBaseModel<void>> {
    return this.httpClient
      .post<IBaseModel<void>>(`${this.apiBaseUrl}/tipodispensa/${id}/reativar`, {})
      .toPromise();
  }

  public async inativar(id: number): Promise<IBaseModel<void>> {
    return this.httpClient
      .post<IBaseModel<void>>(`${this.apiBaseUrl}/tipodispensa/${id}/inativar`, {})
      .toPromise();
  }

  public async excluir(id: number): Promise<IBaseModel<void>> {
    return this.httpClient
      .delete<IBaseModel<void>>(`${this.apiBaseUrl}/tipodispensa/${id}/excluir`, {})
      .toPromise();
  }
}
